import { useState, useCallback } from 'react';

export const useFormFilterBadge = (form) => {
    const [activeFilterCount, setActiveFilterCount] = useState(0);
    const [initialFormValues, setInitialFormValues] = useState({});
    const [isInitialLoadComplete, setIsInitialLoadComplete] = useState(false);

    const onLoadComplete = useCallback(() => {
        if (!isInitialLoadComplete) {
            setInitialFormValues(form.getFieldsValue(true));
            setIsInitialLoadComplete(true);
        }
    }, [isInitialLoadComplete, form]);

    const handleValuesChange = useCallback(() => {
        if (isInitialLoadComplete) {
            let count = 0;
            const currentValues = form.getFieldsValue();

            const isEmpty = (val) => val === null || val === undefined || val === '' || (Array.isArray(val) && val.length === 0);

            // Compare current values against the captured initial state
            Object.keys(currentValues).forEach(key => {
                const initialValue = initialFormValues[key];
                const currentValue = currentValues[key];

                if (!isEmpty(currentValue) && JSON.stringify(initialValue) !== JSON.stringify(currentValue)) {
                    count++;
                }
            });
            setActiveFilterCount(count);
        }
    }, [isInitialLoadComplete, initialFormValues, form]);

    return {
        activeFilterCount,
        onLoadComplete,
        handleValuesChange,
    };
};